import { UseCasesMenu } from "../landing/UseCasesMenu";
import { YearEndStrip } from "../landing/YearEndStrip";
import { useSiteHeaderHeight } from "../landing/useSiteHeaderHeight";

interface CaseStudyNavProps {
  navLabel: string;
  /** Nav CTA text. Defaults to the site-wide primary CTA. */
  ctaLabel?: string;
}

/**
 * Minimal top nav for use-case landing pages. Intentionally lighter than the
 * marketing LandingNav — no centered word-cycler — to keep the editorial
 * register of the page. Shares the seasonal strip with the landing page.
 */
export const CaseStudyNav = ({
  navLabel,
  ctaLabel = "Get free mockup",
}: CaseStudyNavProps) => {
  const headerRef = useSiteHeaderHeight<HTMLElement>();
  return (
    <header ref={headerRef} className="fixed top-0 inset-x-0 z-50">
      <YearEndStrip formId="talk-to-us" />
      <nav className="h-16 px-6 lg:px-12 flex items-center justify-between bg-fwd-soft/95 backdrop-blur-sm border-b border-fwd-ink/10">
        <div className="flex items-center gap-4">
          <a
            href="/"
            className="font-display text-lg tracking-tight whitespace-nowrap shrink-0 hover:opacity-80 transition-opacity flex items-center gap-2"
          >
            <span aria-hidden="true" className="text-fwd-red">
              &larr;
            </span>
            <span>FORWARD</span>
          </a>
          <span className="hidden md:inline text-fwd-mid/40 text-sm font-light select-none">
            |
          </span>
          <span className="hidden md:inline text-fwd-mid text-[0.7rem] font-semibold tracking-[0.18em] uppercase">
            {navLabel}
          </span>
        </div>
        <div className="flex items-center gap-4 sm:gap-6">
          <UseCasesMenu triggerClassName="text-fwd-mid hover:text-fwd-ink" />
          <a
            href="#talk-to-us"
            className="bg-fwd-ink text-white text-[0.65rem] sm:text-xs font-semibold tracking-widest uppercase whitespace-nowrap px-4 sm:px-5 py-2 sm:py-2.5 rounded hover:opacity-90 transition-opacity"
          >
            {ctaLabel}
          </a>
        </div>
      </nav>
    </header>
  );
};
